import { useState } from "react";
import PropTypes from "prop-types";
import ClassificationModal from "./ClassificationsModal/ClassificationsModal";
import ClassificationButton from "./ClassificationButton/ClassificationButton";
import ComponentAccessControl from "components/essentials/ComponentAccessControl/ComponentAccessControl";
import { CLASSIFICATION_CREATE_PERMISSION } from "../../permissions";
import "./ClassificationsHeader.scss";

const ClassificationsHeader = ({ count, handleSuccess, prevAssigned }) => {
    const [showModal, setShowModal] = useState(false);

    const closeModal = () => setShowModal(false);

    return (
        <>
            <div className='classification__header'>
                <h1 className='classification__header--text'>
                    Classifications{" "}
                    <span className='custom-badge custom-badge--light'>
                        {count}
                    </span>
                </h1>
                <ComponentAccessControl
                    baseResources={CLASSIFICATION_CREATE_PERMISSION}>
                    <ClassificationButton setShowModal={setShowModal} />
                </ComponentAccessControl>{" "}
            </div>
            {showModal && (
                <ClassificationModal
                    showModal={showModal}
                    closeModal={closeModal}
                    handleSuccess={handleSuccess}
                    prevAssigned={prevAssigned}
                />
            )}
        </>
    );
};

ClassificationsHeader.prototypes = {
    count: PropTypes.number.isRequired,
    capsuleClasses: PropTypes.array.isRequired,
};

export default ClassificationsHeader;
